export default function PrimaryButton({title, loading, disabled}) {
    return (
        <button disabled={loading || disabled} className="btn btn-lg btn-primary"  type="submit">
            {!loading && <span>{title}</span>}
            {loading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
        </button>
    )
}